<app-shell>
  <router-outlet />
</app-shell>
